"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var SpringboardEngagementMenu_1 = require("./SpringboardEngagementMenu");
exports.default = angular
    .module("publicSpringboardEngagement", [])
    .directive("publicSpringboardEngagement", function ($rootScope, createUi) {
    return {
        restrict: "E",
        template: "\n      <div ui=\"springboardEngagementMenu\" ng-if=\"showMenu\" is-in-navigation=isInNavigation></div>\n      ",
        scope: {
            isInNavigation: "=?",
        },
        controller: function ($scope) {
            $scope.showMenu = $rootScope.di.get("showSpringboardEngagementMenu");
            $scope.springboardEngagementMenu = (0, SpringboardEngagementMenu_1.mountSpringboardEngagementMenu)((0, MountReactComponent_1.default)(createUi, $rootScope.di), {
                isInline: $scope.isInNavigation,
            });
        },
    };
});
